(() => {
  const init = (root) => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const grid = root.querySelector('[data-brand-grid]');
    const cards = [...grid.querySelectorAll('[data-brand-name]')];
    const search = root.querySelector('[data-brand-search]');
    const sort = root.querySelector('[data-brand-sort]');
    const empty = root.querySelector('[data-brand-empty]');
    const count = root.querySelector('[data-brand-count]');
    const alphabet = root.querySelector('[data-brand-alphabet]');
    const letterButtons = [...alphabet.querySelectorAll('[data-brand-letter]')];
    let activeLetter = '';
    const locale = document.documentElement.lang || 'de';
    const collator = new Intl.Collator(locale, { sensitivity: 'base', numeric: true });
    const normalize = (value) => value.normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase(locale).trim();
    const update = () => {
      const query = normalize(search.value);
      let visible = 0;
      cards.sort((a, b) => collator.compare(a.dataset.brandName, b.dataset.brandName) * (sort.value === 'desc' ? -1 : 1));
      const fragment = document.createDocumentFragment();
      cards.forEach((card) => {
        const matchesQuery = normalize(card.dataset.brandName).includes(query);
        const matchesLetter = !activeLetter || card.dataset.brandInitial === activeLetter;
        card.hidden = !(matchesQuery && matchesLetter);
        if (!card.hidden) visible += 1;
        fragment.append(card);
      });
      grid.append(fragment);
      count.textContent = count.dataset.countLabel.replace('__COUNT__', visible);
      empty.hidden = visible !== 0;
    };
    search.addEventListener('input', update);
    sort.addEventListener('change', update);
    letterButtons.forEach((button) => {
      if (button.dataset.brandLetter && !cards.some((card) => card.dataset.brandInitial === button.dataset.brandLetter)) button.disabled = true;
      button.addEventListener('click', () => {
        activeLetter = button.dataset.brandLetter;
        letterButtons.forEach((item) => item.classList.toggle('is-active', item === button));
        update();
      });
    });
    root.querySelector('[data-brand-reset]').addEventListener('click', () => { search.value = ''; sort.value = 'asc'; activeLetter = ''; letterButtons.forEach((item) => item.classList.toggle('is-active', item.dataset.brandLetter === '')); update(); search.focus(); });
    root.querySelector('[data-brand-controls]').hidden = false;
    alphabet.hidden = false;
    update();
  };
  document.querySelectorAll('[data-ms-brands]').forEach(init);
  document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('[data-ms-brands]').forEach(init));
})();
